import { DataService } from "@bb-vendure/admin-ui/core";
import { take, forkJoin } from "rxjs";
import { BulkAction, ModalService } from "@bb-vendure/admin-ui/core";

export const bulkLevelDelete: BulkAction = {
  location: "user-level-table",
  label: "Delete Selectd",
  icon: "trash",
  requiresPermission: (userPermissions) => {
    return userPermissions.includes("DeleteUserLevel");
  },
  onClick: ({ injector, selection, clearSelection, hostComponent }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Customer Levels",
        body: `Are you sure you want to delete ${selection.length} customer levels?`,
        buttons: [
          { label: "Cancel", type: "secondary" },
          { label: "Delete", type: "danger", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          const tasks = res.map((level) => {
            console.log("Delete ", level.id);
            // return dataService.mutate(DeleteUserLevelDocument, {
            //   id: level.id,
            // });
          });

          //   forkJoin(tasks).subscribe((results) => {
          //     console.log("All tasks completed");
          //   });
        }
      });
  },
};
